import * as Files from './Files';

export default {
  Files,
};
